import { createApp } from 'vue'
import App from './App.vue'
import router from './router/main'
//element
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import selectUtils from "@/assets/js/utils-select"
import dateUtils from './assets/js/utils-date';
import commonUtils from './assets/js/utils-common';
import 'viewerjs/dist/viewer.css'

const app = createApp(App)

app.use(router)
app.use(ElementPlus)
app.mount('#app')
app.config.globalProperties.$selectUtils = selectUtils // 自定义添加
app.config.globalProperties.$dateUtils = dateUtils // 自定义添加
app.config.globalProperties.$commonUtils = commonUtils // 自定义添加
//添加所有elementUI 图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}
